'use client';
import { __rest } from 'tslib';
import React from 'react';
import * as MenuPrimitive from '@radix-ui/react-menu';
import { CheckIcon } from '@radix-ui/react-icons';
import { css, styled } from '../stitches.config.js';
import { Box } from './Box.js';
import { Flex } from './Flex.js';
import { panelStyles } from './Panel.js';

const baseItemCss = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: '$untitled',
    fontSize: '$1',
    fontVariantNumeric: 'tabular-nums',
    lineHeight: '1',
    cursor: 'default',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    height: '$5',
    px: '$5',
});
const itemCss = css(baseItemCss, {
    position: 'relative',
    color: '$hiContrast',
    '&[data-highlighted]': {
        outline: 'none',
        backgroundColor: '$info9',
        color: '$loContrast',
    },
    '&[data-disabled]': {
        color: '$gray9',
    },
});
const labelCss = css(baseItemCss, {
    color: '$gray11',
});
const menuCss = css({
    boxSizing: 'border-box',
    minWidth: 120,
    py: '$1',
});
const separatorCss = css({
    height: 1,
    my: '$1',
    backgroundColor: '$gray6',
});
const Menu = styled(MenuPrimitive.Root, menuCss);
styled(MenuPrimitive.Content, panelStyles);
const MenuSeparator = styled(MenuPrimitive.Separator, separatorCss);
const MenuItem = styled(MenuPrimitive.Item, itemCss);
const StyledMenuRadioItem = styled(MenuPrimitive.RadioItem, itemCss);
const MenuRadioItem = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledMenuRadioItem, Object.assign({}, props, { ref: forwardedRef }),
        React.createElement(Box, { as: "span", css: { position: 'absolute', left: '$1' } },
            React.createElement(MenuPrimitive.ItemIndicator, null,
                React.createElement(Flex, { css: { width: '$3', height: '$3', alignItems: 'center', justifyContent: 'center' } },
                    React.createElement(Box, { css: {
                            width: '$1',
                            height: '$1',
                            backgroundColor: 'currentColor',
                            borderRadius: '$round',
                        } })))),
        children));
});
const StyledMenuCheckboxItem = styled(MenuPrimitive.CheckboxItem, itemCss);
const MenuCheckboxItem = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledMenuCheckboxItem, Object.assign({}, props, { ref: forwardedRef }),
        React.createElement(Box, { as: "span", css: { position: 'absolute', left: '$1' } },
            React.createElement(MenuPrimitive.ItemIndicator, null,
                React.createElement(CheckIcon, null))),
        children));
});
const MenuLabel = styled(MenuPrimitive.Label, labelCss);
const MenuRadioGroup = styled(MenuPrimitive.RadioGroup, {});
const MenuGroup = styled(MenuPrimitive.Group, {});

export { Menu, MenuCheckboxItem, MenuGroup, MenuItem, MenuLabel, MenuRadioGroup, MenuRadioItem, MenuSeparator, baseItemCss, itemCss, labelCss, menuCss, separatorCss };
